import React from 'react';
import MeetingMoreMembersIndicator from 'flow/components/meeting/MeetingMoreMembersIndicator';
import MeetingViewMenu from 'flow/components/meeting/shared/MeetingViewMenu';
import ButtonHangUp from './footer/ButtonHangUp';

const MeetingMinimizedFooter: React.FC = () => {
    return (
        <div className="ms-auto flex items-center justify-end gap-3 pe-3">
            <MeetingMoreMembersIndicator />
            <ButtonHangUp />
            {/* Same treatment BottomBarFooter gives its menu on this bar:
                the bar is black and sets no colour, and ContextMenu's default
                grey plate would read as a lit button against it. */}
            <MeetingViewMenu className="bg-transparent text-white hover:bg-gray-600" />
        </div>
    );
};

export default MeetingMinimizedFooter;
